import rangeBrushComponent from './range';

export default function rangeBrush(picasso) {
  picasso.component('range', rangeBrushComponent);
}
